import classNames from 'classnames'
import './Drawer.scss'

interface DrawerFooterProps {
  align?: 'left' | 'right'
  children?: React.ReactNode
}

export const DrawerFooter: React.FC<DrawerFooterProps> = ({
  align = 'left',
  children,
}) => {
  return <div className={classNames('drawer-footer', align)}>{children}</div>
}
